import React, { useState, useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import VenueOwnerLayout from './VenueOwnerLayout';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function VenueOwnerShell() {
  const [club, setClub] = useState(null);
  const [trialStatus, setTrialStatus] = useState(null);
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);

  const reloadVenues = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/venues`, auth());
      setVenues(res.data || []);
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const [clubRes, trialRes] = await Promise.all([
          axios.get(`${API}/clubs/current`, auth()).catch(() => ({ data: null })),
          axios.get(`${API}/saas/my-club/trial-status`, auth()).catch(() => ({ data: null })),
        ]);
        setClub(clubRes.data);
        setTrialStatus(trialRes.data);
        await reloadVenues();
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [reloadVenues]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f6f7fb]" data-testid="venue-owner-shell-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-orange-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <VenueOwnerLayout club={club} trialStatus={trialStatus}>
      <Outlet context={{ club, trialStatus, venues, reloadVenues }} />
    </VenueOwnerLayout>
  );
}
